import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";

interface FormOptionsProps {
  selectedOption: { key: string; label: string; table?: string };
  options: { key: string; label: string; table?: string }[];
  placeholder?: string;
  onOptionSelect: (option: string, table?: string) => void;
  group?:
    | "down"
    | "down-left"
    | "down-right"
    | "left"
    | "right"
    | "up"
    | "up-left"
    | "up-right"
    | "single"
    | "middle"
    | "middle-right"
    | "middle-left";
}
export const FormOptions = ({
  selectedOption,
  options,
  placeholder,
  onOptionSelect,
  group,
}: FormOptionsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="tertiary"
          group={group}
          className={cn(
            "h-full max-w-1/2 gap-2",
            !selectedOption?.label && "text-body-quiet",
          )}
        >
          <span className="truncate min-w-0">
            {selectedOption?.label ?? placeholder}
          </span>
          <Icon type="fas" name="chevron-down" className="shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="start"
        className={cn(
          "max-h-37.25 min-w-20 w-(--radix-dropdown-menu-trigger-width) rounded-lg border-neutral-silent text-body-loud font-semibold bg-neutral-object",
        )}
      >
        {options.map((option) => (
          <DropdownMenuItem
            key={option.key}
            onSelect={() => onOptionSelect(option.key, option.table)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
